import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaFacebook, FaYoutube, FaLinkedin, FaGithub, FaWhatsapp, FaInstagram } from "react-icons/fa";
import FooterListTitle from "./FooterListTitle";
import { paymentCard } from "../../../assets/images";
import Image from "../../designLayouts/Image";

const Footer = () => {
  const [emailInfo, setEmailInfo] = useState("");
  const [subscription, setSubscription] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const emailValidation = () => {
    return String(emailInfo)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleSubscription = () => {
    if (emailInfo === "") {
      setErrMsg("Please provide an Email!");
    } else if (!emailValidation(emailInfo)) {
      setErrMsg("Please provide a valid Email!");
    } else {
      setSubscription(true);
      setErrMsg("");
      setEmailInfo("");
    }
  };

  return (
    <div className="w-full bg-[#F5F5F3] py-20">
      <div className="max-w-container mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 px-4 gap-10">

        {/* About Company */}
        <div className="col-span-2">
          <FooterListTitle title="More about BigMart General Trading LLC" />
          <div className="flex flex-col gap-6">
            <p className="text-base w-full xl:w-[80%]">
              BigMart General Trading LLC is your trusted general trading company in Ajman, Jurf 1, UAE. 
              We specialize in quality products and excellent customer service.
            </p>

            {/* Social Media */}
            <ul className="flex items-center gap-2">

              <a href="https://instagram.com/bcc.mart_" target="_blank" rel="noreferrer">
                <li className="w-7 h-7 bg-primeColor text-gray-100 hover:text-white cursor-pointer text-lg rounded-full flex justify-center items-center hover:bg-black duration-300">
                  <FaInstagram />
                </li>
              </a>


              <a href="https://www.linkedin.com/company/bccmart-hypermarket" target="_blank" rel="noreferrer">
                <li className="w-7 h-7 bg-primeColor text-gray-100 hover:text-white cursor-pointer text-lg rounded-full flex justify-center items-center hover:bg-black duration-300">
                  <FaLinkedin />
                </li>
              </a>

              <a href="https://wa.me/971542660433" target="_blank" rel="noreferrer">
                <li className="w-7 h-7 bg-primeColor text-gray-100 hover:text-white cursor-pointer text-lg rounded-full flex justify-center items-center hover:bg-black duration-300">
                  <FaWhatsapp />
                </li>
              </a>

            </ul>
          </div>
        </div>

        {/* Enquiry Links */}
        <div className="col-span-1 md:col-span-1">
          <FooterListTitle title="Enquiry" />
          <ul className="flex flex-col gap-2">
            <li>
              <a
                href="https://wa.me/971542660433"
                target="_blank"
                rel="noreferrer"
                className="font-titleFont text-base text-lightText hover:text-black hover:underline decoration-[1px] decoration-gray-500 underline-offset-2 cursor-pointer duration-300 flex items-center gap-2"
              >
                <FaWhatsapp /> General Enquiry
              </a>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="col-span-3 flex flex-col items-center w-full px-4">
          <FooterListTitle title="Subscribe to our newsletter" />
          <p className="text-center mb-4">
            Stay updated with our latest products and offers.
          </p>

          {subscription ? (
            <motion.p
              initial={{ x: 20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="w-full text-center text-base font-titleFont font-semibold text-green-600"
            >
              Subscribed Successfully!
            </motion.p>
          ) : (
            <div className="w-full flex-col xl:flex-row flex justify-between items-center gap-4">
              <div className="flex flex-col w-full">
                <input
                  onChange={(e) => setEmailInfo(e.target.value)}
                  value={emailInfo}
                  className="w-full h-12 border-b border-gray-400 bg-transparent px-4 text-primeColor text-lg placeholder:text-base outline-none"
                  type="text"
                  placeholder="Insert your email ...*"
                />
                {errMsg && (
                  <p className="text-red-600 text-sm font-semibold font-titleFont text-center animate-bounce mt-2">
                    {errMsg}
                  </p>
                )}
              </div>

              <button
                onClick={handleSubscription}
                className="bg-white text-lightText w-[30%] h-10 hover:bg-black hover:text-white duration-300 text-base tracking-wide"
              >
                Subscribe
              </button>
            </div>
          )}

          <Image
            className={`w-[80%] lg:w-[60%] mx-auto ${
              subscription ? "mt-2" : "mt-6"
            }`}
            imgSrc={paymentCard}
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;